export default __webpack_public_path__ + "static/am-blog-sm-4721e43d66d1d41b844925c8164d5903.jpg";